// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Caml_format from "melange.js/caml_format.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as ReasonReactRouter from "reason-react/ReasonReactRouter.js";
import * as Stdlib from "melange/stdlib.js";
import * as React from "react";

function isProtected(param) {
  if (typeof param === "number") {
    if (param === /* OrgChoose */0) {
      return true;
    } else {
      return false;
    }
  }
  switch (param.TAG | 0) {
    case /* Auth */0 :
        return param._0 === 1;
    case /* Profile */5 :
    case /* Org */6 :
    case /* Admin */7 :
        return true;
    default:
      return false;
  }
}

function getListStateUrl(baseUrl, state) {
  if (typeof state === "number") {
    if (state === /* List */0) {
      return baseUrl;
    } else {
      return baseUrl + "/create";
    }
  } else if (state.TAG === /* View */0) {
    return baseUrl + ("/" + String(state._0));
  } else {
    return baseUrl + ("/" + (String(state._0) + "/edit"));
  }
}

function getListStateStrUrl(baseUrl, state) {
  if (typeof state === "number") {
    if (state === /* List */0) {
      return baseUrl;
    } else {
      return baseUrl + "/create";
    }
  } else if (state.TAG === /* View */0) {
    return baseUrl + ("/" + state._0);
  } else {
    return baseUrl + ("/" + (state._0 + "/edit"));
  }
}

function orgUri(listState) {
  if (typeof listState === "number") {
    if (listState === /* Dashboard */0) {
      return "";
    } else {
      return "/bank";
    }
  }
  switch (listState.TAG | 0) {
    case /* Catalog */0 :
        return getListStateUrl("/catalog/items", listState._0);
    case /* Documents */1 :
        const documents = listState._0;
        if (typeof documents === "number") {
          return "/edo/settings";
        }
        switch (documents.TAG | 0) {
          case /* Contracts */0 :
              return getListStateUrl("/edo/contracts", documents._0);
          case /* Invoices */1 :
              return getListStateUrl("/edo/invoices", documents._0);
          case /* Workstatements */2 :
              return getListStateUrl("/edo/awps", documents._0);
          case /* Consignments */3 :
              return getListStateUrl("/edo/consignments", documents._0);
          case /* Facturas */4 :
              return getListStateUrl("/edo/facturas", documents._0);
          case /* Appendices */5 :
              return getListStateUrl("/edo/appendices", documents._0);
          case /* Batches */6 :
              const batches = documents._0;
              let tmp;
              tmp = typeof batches === "number" ? "" : (
                  batches.TAG === /* View */0 ? "/" + batches._0 : "/" + (batches._0 + "/sign")
                );
              return "/edo/batches" + tmp;
          
        }
    case /* Kassa */2 :
        const route = listState._0._0;
        let uri;
        if (typeof route === "number") {
          uri = route ? "" : "/create";
        } else {
          const rest = route._1;
          const id = String(route._0);
          if (typeof rest === "number") {
            switch (rest) {
              case /* Start */0 :
                  uri = "/" + (id + "/start");
                  break;
              case /* Register */1 :
                  uri = "/" + (id + "/register");
                  break;
              case /* Link */2 :
                  uri = "/" + (id + "/link");
                  break;
              case /* View */3 :
                  uri = "/" + id;
                  break;
              case /* Cashbox */4 :
                  uri = "/" + (id + "/cashbox");
                  break;
              
            }
          } else {
            switch (rest.TAG | 0) {
              case /* Settings */0 :
                  switch (rest._0) {
                    case /* General */0 :
                        uri = "/" + (id + "/settings");
                        break;
                    case /* Etp */1 :
                        uri = "/" + (id + "/settings/etp");
                        break;
                    case /* Connection */2 :
                        uri = "/" + (id + "/settings/connection");
                        break;
                    case /* Ofd */3 :
                        uri = "/" + (id + "/settings/ofd");
                        break;
                    
                  }
                  break;
              case /* Receipts */1 :
                  const rcp = rest._0;
                  uri = typeof rcp === "number" ? (
                      rcp === /* List */0 ? "/" + (id + "/receipts") : "/" + (id + "/receipts")
                    ) : (
                      rcp.TAG === /* View */0 ? "/" + (id + ("/receipts/" + rcp._0)) : "/" + (id + "/receipts")
                    );
                  break;
              case /* Journal */2 :
                  const match = rest._0;
                  if (typeof match === "number") {
                    uri = match ? "/" + (id + "/journal/money-placements") : "/" + (id + "/journal");
                  } else {
                    const shift = match._0;
                    uri = typeof shift === "number" ? "/" + (id + "/journal/shifts") : (
                        shift.TAG === /* View */0 ? "/" + (id + ("/journal/shifts/" + shift._0)) : "/" + (id + "/journal/shifts")
                      );
                  }
                  break;
              case /* Reports */3 :
                  uri = getListStateStrUrl("/" + (id + "/reports"), rest._0);
                  break;
              
            }
          }
        }
        return "/kassa/kkms" + uri;
    case /* Sklad */3 :
        const sklad = listState._0;
        if (typeof sklad === "number") {
          return "/sklad/remains";
        }
        if (sklad.TAG !== /* Procurements */0) {
          return getListStateUrl("/sklad/warehouses", sklad._0);
        }
        const procurements = sklad._0;
        if (procurements.TAG === /* Orders */0) {
          return getListStateUrl("/sklad/procurements/orders", procurements._0);
        } else {
          return getListStateUrl("/sklad/procurements/receives", procurements._0);
        }
    case /* Tax */4 :
        const tax = listState._0;
        if (typeof tax === "number") {
          return "/tax/settings";
        }
        if (tax.TAG !== /* Payments */0) {
          return getListStateUrl("/tax/reports", tax._0);
        }
        const match$1 = tax._0;
        if (typeof match$1 === "number") {
          switch (match$1) {
            case /* Index */0 :
                return "/tax/payments";
            case /* Settings */1 :
                return "/tax/payments/settings";
            case /* New */2 :
                return "/tax/payments/new";
            case /* Create */3 :
                return "/tax/payments/employee/create";
            
          }
        } else {
          switch (match$1._0) {
            case /* Index */0 :
                return "/tax/payments/orders/create";
            case /* Create */1 :
                return "/tax/payments/orders/employee/create";
            case /* Checkout */2 :
                return "/tax/payments/orders/checkout";
            
          }
        }
    case /* Hrm */5 :
        const state = listState._0._0;
        if (typeof state === "number") {
          if (state === /* Index */0) {
            return "/hrm/employees";
          } else {
            return "/hrm/employees/create";
          }
        } else if (state.TAG === /* View */0) {
          return "/hrm/employees/" + state._0;
        } else {
          return "/hrm/employees/" + (state._0 + "/edit");
        }
    case /* Payroll */6 :
        const payroll = listState._0;
        if (payroll.TAG === /* Employees */0) {
          const state$1 = payroll._0;
          if (typeof state$1 === "number") {
            if (state$1 === /* List */0) {
              return "/payroll/employees";
            } else {
              return "/payroll/employees/create";
            }
          } else if (state$1.TAG === /* View */0) {
            return "/payroll/employees/" + state$1._0;
          } else {
            return "/payroll/employees/" + (state$1._0 + "/edit");
          }
        }
        const state$2 = payroll._0;
        if (typeof state$2 === "number") {
          if (state$2 === /* List */0) {
            return "/payroll/payouts";
          } else {
            return "";
          }
        } else if (state$2.TAG === /* View */0) {
          return "/payroll/payouts/" + state$2._0;
        } else {
          return "";
        }
    case /* Manage */7 :
        const manage = listState._0;
        if (manage) {
          return getListStateStrUrl("/manage/contractors", manage._0);
        } else {
          return "/manage/products";
        }
    case /* Settings */8 :
        switch (listState._0) {
          case /* General */0 :
              return "/settings";
          case /* Brand */1 :
              return "/settings/brand";
          case /* Chief */2 :
              return "/settings/chief";
          case /* Tax */3 :
              return "/settings/tax";
          
        }
    
  }
}

function orgRoute(param) {
  if (!param) {
    return /* Dashboard */0;
  }
  switch (param.hd) {
    case "bank" :
        if (param.tl) {
          return /* Dashboard */0;
        } else {
          return /* Bank */1;
        }
    case "catalog" :
        const match = param.tl;
        if (!match) {
          return /* Dashboard */0;
        }
        if (match.hd !== "items") {
          return /* Dashboard */0;
        }
        const rest = match.tl;
        if (!rest) {
          return {
                  TAG: /* Catalog */0,
                  _0: /* List */0
                };
        }
        const id = rest.hd;
        if (id === "create" && !rest.tl) {
          return {
                  TAG: /* Catalog */0,
                  _0: /* Create */1
                };
        }
        const match$1 = rest.tl;
        if (match$1) {
          if (match$1.hd === "edit" && !match$1.tl) {
            return {
                    TAG: /* Catalog */0,
                    _0: {
                      TAG: /* Edit */1,
                      _0: Caml_format.caml_int_of_string(id)
                    }
                  };
          } else {
            return {
                    TAG: /* Catalog */0,
                    _0: /* List */0
                  };
          }
        } else {
          return {
                  TAG: /* Catalog */0,
                  _0: {
                    TAG: /* View */0,
                    _0: Caml_format.caml_int_of_string(id)
                  }
                };
        }
        break;
    case "edo" :
        const rest$1 = param.tl;
        if (!rest$1) {
          return {
                  TAG: /* Documents */1,
                  _0: {
                    TAG: /* Facturas */4,
                    _0: /* List */0
                  }
                };
        }
        switch (rest$1.hd) {
          case "appendices" :
              const rest$2 = rest$1.tl;
              if (!rest$2) {
                return {
                        TAG: /* Documents */1,
                        _0: {
                          TAG: /* Appendices */5,
                          _0: /* List */0
                        }
                      };
              }
              const id$1 = rest$2.hd;
              if (id$1 === "create") {
                if (rest$2.tl) {
                  return {
                          TAG: /* Documents */1,
                          _0: {
                            TAG: /* Appendices */5,
                            _0: /* List */0
                          }
                        };
                } else {
                  return {
                          TAG: /* Documents */1,
                          _0: {
                            TAG: /* Appendices */5,
                            _0: /* Create */1
                          }
                        };
                }
              } else if (rest$2.tl) {
                return {
                        TAG: /* Documents */1,
                        _0: {
                          TAG: /* Appendices */5,
                          _0: /* List */0
                        }
                      };
              } else {
                return {
                        TAG: /* Documents */1,
                        _0: {
                          TAG: /* Appendices */5,
                          _0: {
                            TAG: /* View */0,
                            _0: Caml_format.caml_int_of_string(id$1)
                          }
                        }
                      };
              }
          case "awps" :
              const rest$3 = rest$1.tl;
              if (!rest$3) {
                return {
                        TAG: /* Documents */1,
                        _0: {
                          TAG: /* Workstatements */2,
                          _0: /* List */0
                        }
                      };
              }
              const id$2 = rest$3.hd;
              if (id$2 === "create" && !rest$3.tl) {
                return {
                        TAG: /* Documents */1,
                        _0: {
                          TAG: /* Workstatements */2,
                          _0: /* Create */1
                        }
                      };
              }
              const match$2 = rest$3.tl;
              if (match$2) {
                if (match$2.hd === "edit" && !match$2.tl) {
                  return {
                          TAG: /* Documents */1,
                          _0: {
                            TAG: /* Workstatements */2,
                            _0: {
                              TAG: /* Edit */1,
                              _0: Caml_format.caml_int_of_string(id$2)
                            }
                          }
                        };
                } else {
                  return {
                          TAG: /* Documents */1,
                          _0: {
                            TAG: /* Workstatements */2,
                            _0: /* List */0
                          }
                        };
                }
              } else {
                return {
                        TAG: /* Documents */1,
                        _0: {
                          TAG: /* Workstatements */2,
                          _0: {
                            TAG: /* View */0,
                            _0: Caml_format.caml_int_of_string(id$2)
                          }
                        }
                      };
              }
              break;
          case "batches" :
              const rest$4 = rest$1.tl;
              if (!rest$4) {
                return {
                        TAG: /* Documents */1,
                        _0: {
                          TAG: /* Batches */6,
                          _0: /* List */0
                        }
                      };
              }
              const match$3 = rest$4.tl;
              const id$3 = rest$4.hd;
              if (match$3) {
                if (match$3.hd === "sign" && !match$3.tl) {
                  return {
                          TAG: /* Documents */1,
                          _0: {
                            TAG: /* Batches */6,
                            _0: {
                              TAG: /* Sign */1,
                              _0: id$3
                            }
                          }
                        };
                } else {
                  return {
                          TAG: /* Documents */1,
                          _0: {
                            TAG: /* Batches */6,
                            _0: /* List */0
                          }
                        };
                }
              } else {
                return {
                        TAG: /* Documents */1,
                        _0: {
                          TAG: /* Batches */6,
                          _0: {
                            TAG: /* View */0,
                            _0: id$3
                          }
                        }
                      };
              }
          case "consignments" :
              return {
                      TAG: /* Documents */1,
                      _0: {
                        TAG: /* Consignments */3,
                        _0: /* List */0
                      }
                    };
          case "contracts" :
              const rest$5 = rest$1.tl;
              if (!rest$5) {
                return {
                        TAG: /* Documents */1,
                        _0: {
                          TAG: /* Contracts */0,
                          _0: /* List */0
                        }
                      };
              }
              const id$4 = rest$5.hd;
              if (id$4 === "create") {
                if (rest$5.tl) {
                  return {
                          TAG: /* Documents */1,
                          _0: {
                            TAG: /* Contracts */0,
                            _0: /* List */0
                          }
                        };
                } else {
                  return {
                          TAG: /* Documents */1,
                          _0: {
                            TAG: /* Contracts */0,
                            _0: /* Create */1
                          }
                        };
                }
              } else if (rest$5.tl) {
                return {
                        TAG: /* Documents */1,
                        _0: {
                          TAG: /* Contracts */0,
                          _0: /* List */0
                        }
                      };
              } else {
                return {
                        TAG: /* Documents */1,
                        _0: {
                          TAG: /* Contracts */0,
                          _0: {
                            TAG: /* View */0,
                            _0: Caml_format.caml_int_of_string(id$4)
                          }
                        }
                      };
              }
          case "facturas" :
              return {
                      TAG: /* Documents */1,
                      _0: {
                        TAG: /* Facturas */4,
                        _0: /* List */0
                      }
                    };
          case "invoices" :
              return {
                      TAG: /* Documents */1,
                      _0: {
                        TAG: /* Invoices */1,
                        _0: /* List */0
                      }
                    };
          case "settings" :
              if (rest$1.tl) {
                return {
                        TAG: /* Documents */1,
                        _0: {
                          TAG: /* Facturas */4,
                          _0: /* List */0
                        }
                      };
              } else {
                return {
                        TAG: /* Documents */1,
                        _0: /* Settings */0
                      };
              }
          default:
            return {
                    TAG: /* Documents */1,
                    _0: {
                      TAG: /* Facturas */4,
                      _0: /* List */0
                    }
                  };
        }
        break;
    case "hrm" :
        const rest$6 = param.tl;
        if (!rest$6) {
          return {
                  TAG: /* Hrm */5,
                  _0: /* Employees */{
                    _0: /* Index */0
                  }
                };
        }
        if (rest$6.hd !== "employees") {
          return {
                  TAG: /* Hrm */5,
                  _0: /* Employees */{
                    _0: /* Index */0
                  }
                };
        }
        const match$4 = rest$6.tl;
        if (!match$4) {
          return {
                  TAG: /* Hrm */5,
                  _0: /* Employees */{
                    _0: /* Index */0
                  }
                };
        }
        const id$5 = match$4.hd;
        if (id$5 === "create" && !match$4.tl) {
          return {
                  TAG: /* Hrm */5,
                  _0: /* Employees */{
                    _0: /* Create */1
                  }
                };
        }
        const match$5 = match$4.tl;
        if (match$5) {
          if (match$5.hd === "edit" && !match$5.tl) {
            return {
                    TAG: /* Hrm */5,
                    _0: /* Employees */{
                      _0: {
                        TAG: /* Edit */1,
                        _0: id$5
                      }
                    }
                  };
          } else {
            return {
                    TAG: /* Hrm */5,
                    _0: /* Employees */{
                      _0: /* Index */0
                    }
                  };
          }
        } else {
          return {
                  TAG: /* Hrm */5,
                  _0: /* Employees */{
                    _0: {
                      TAG: /* View */0,
                      _0: id$5
                    }
                  }
                };
        }
        break;
    case "kassa" :
        const kassa = param.tl;
        if (!kassa) {
          return /* Dashboard */0;
        }
        if (kassa.hd !== "kkms") {
          return /* Dashboard */0;
        }
        const rest$7 = kassa.tl;
        let subRoute;
        if (rest$7) {
          const id$6 = rest$7.hd;
          let exit = 0;
          if (id$6 === "create" && !rest$7.tl) {
            subRoute = /* Create */0;
          } else {
            exit = 1;
          }
          if (exit === 1) {
            const match$6 = rest$7.tl;
            if (match$6) {
              switch (match$6.hd) {
                case "cashbox" :
                    subRoute = match$6.tl ? /* List */1 : /* Kkm */({
                          _0: Caml_format.caml_int_of_string(id$6),
                          _1: /* Cashbox */4
                        });
                    break;
                case "journal" :
                    const match$7 = match$6.tl;
                    if (match$7) {
                      switch (match$7.hd) {
                        case "money-placements" :
                            subRoute = match$7.tl ? /* List */1 : /* Kkm */({
                                  _0: Caml_format.caml_int_of_string(id$6),
                                  _1: {
                                    TAG: /* Journal */2,
                                    _0: /* MoneyPlacements */1
                                  }
                                });
                            break;
                        case "shifts" :
                            const match$8 = match$7.tl;
                            subRoute = match$8 ? (
                                match$8.tl ? /* List */1 : /* Kkm */({
                                      _0: Caml_format.caml_int_of_string(id$6),
                                      _1: {
                                        TAG: /* Journal */2,
                                        _0: /* Shifts */{
                                          _0: {
                                            TAG: /* View */0,
                                            _0: match$8.hd
                                          }
                                        }
                                      }
                                    })
                              ) : /* Kkm */({
                                  _0: Caml_format.caml_int_of_string(id$6),
                                  _1: {
                                    TAG: /* Journal */2,
                                    _0: /* Shifts */{
                                      _0: /* List */0
                                    }
                                  }
                                });
                            break;
                        default:
                          subRoute = /* List */1;
                      }
                    } else {
                      subRoute = /* Kkm */{
                        _0: Caml_format.caml_int_of_string(id$6),
                        _1: {
                          TAG: /* Journal */2,
                          _0: /* Logs */0
                        }
                      };
                    }
                    break;
                case "link" :
                    subRoute = match$6.tl ? /* List */1 : /* Kkm */({
                          _0: Caml_format.caml_int_of_string(id$6),
                          _1: /* Link */2
                        });
                    break;
                case "receipts" :
                    const match$9 = match$6.tl;
                    subRoute = match$9 ? (
                        match$9.tl ? /* List */1 : /* Kkm */({
                              _0: Caml_format.caml_int_of_string(id$6),
                              _1: {
                                TAG: /* Receipts */1,
                                _0: {
                                  TAG: /* View */0,
                                  _0: match$9.hd
                                }
                              }
                            })
                      ) : /* Kkm */({
                          _0: Caml_format.caml_int_of_string(id$6),
                          _1: {
                            TAG: /* Receipts */1,
                            _0: /* List */0
                          }
                        });
                    break;
                case "register" :
                    subRoute = match$6.tl ? /* List */1 : /* Kkm */({
                          _0: Caml_format.caml_int_of_string(id$6),
                          _1: /* Register */1
                        });
                    break;
                case "reports" :
                    const match$10 = match$6.tl;
                    subRoute = match$10 ? (
                        match$10.tl ? /* List */1 : /* Kkm */({
                              _0: Caml_format.caml_int_of_string(id$6),
                              _1: {
                                TAG: /* Reports */3,
                                _0: {
                                  TAG: /* View */0,
                                  _0: match$10.hd
                                }
                              }
                            })
                      ) : /* Kkm */({
                          _0: Caml_format.caml_int_of_string(id$6),
                          _1: {
                            TAG: /* Reports */3,
                            _0: /* List */0
                          }
                        });
                    break;
                case "settings" :
                    const match$11 = match$6.tl;
                    if (match$11) {
                      switch (match$11.hd) {
                        case "connection" :
                            subRoute = match$11.tl ? /* List */1 : /* Kkm */({
                                  _0: Caml_format.caml_int_of_string(id$6),
                                  _1: {
                                    TAG: /* Settings */0,
                                    _0: /* Connection */2
                                  }
                                });
                            break;
                        case "etp" :
                            subRoute = match$11.tl ? /* List */1 : /* Kkm */({
                                  _0: Caml_format.caml_int_of_string(id$6),
                                  _1: {
                                    TAG: /* Settings */0,
                                    _0: /* Etp */1
                                  }
                                });
                            break;
                        case "ofd" :
                            subRoute = match$11.tl ? /* List */1 : /* Kkm */({
                                  _0: Caml_format.caml_int_of_string(id$6),
                                  _1: {
                                    TAG: /* Settings */0,
                                    _0: /* Ofd */3
                                  }
                                });
                            break;
                        default:
                          subRoute = /* List */1;
                      }
                    } else {
                      subRoute = /* Kkm */{
                        _0: Caml_format.caml_int_of_string(id$6),
                        _1: {
                          TAG: /* Settings */0,
                          _0: /* General */0
                        }
                      };
                    }
                    break;
                case "start" :
                    subRoute = match$6.tl ? /* List */1 : /* Kkm */({
                          _0: Caml_format.caml_int_of_string(id$6),
                          _1: /* Start */0
                        });
                    break;
                default:
                  subRoute = /* List */1;
              }
            } else {
              subRoute = /* Kkm */{
                _0: Caml_format.caml_int_of_string(id$6),
                _1: /* View */3
              };
            }
          }
          
        } else {
          subRoute = /* List */1;
        }
        return {
                TAG: /* Kassa */2,
                _0: /* Kkms */{
                  _0: subRoute
                }
              };
        break;
    case "manage" :
        const rest$8 = param.tl;
        if (!rest$8) {
          return {
                  TAG: /* Manage */7,
                  _0: /* Products */0
                };
        }
        switch (rest$8.hd) {
          case "contractors" :
              const state = rest$8.tl;
              if (!state) {
                return {
                        TAG: /* Manage */7,
                        _0: /* Contractors */{
                          _0: /* List */0
                        }
                      };
              }
              const id$7 = state.hd;
              if (id$7 === "create" && !state.tl) {
                return {
                        TAG: /* Manage */7,
                        _0: /* Contractors */{
                          _0: /* Create */1
                        }
                      };
              }
              const match$12 = state.tl;
              if (match$12) {
                if (match$12.hd === "edit" && !match$12.tl) {
                  return {
                          TAG: /* Manage */7,
                          _0: /* Contractors */{
                            _0: {
                              TAG: /* Edit */1,
                              _0: id$7
                            }
                          }
                        };
                } else {
                  return {
                          TAG: /* Manage */7,
                          _0: /* Contractors */{
                            _0: /* List */0
                          }
                        };
                }
              } else {
                return {
                        TAG: /* Manage */7,
                        _0: /* Contractors */{
                          _0: {
                            TAG: /* View */0,
                            _0: id$7
                          }
                        }
                      };
              }
              break;
          case "products" :
              return {
                      TAG: /* Manage */7,
                      _0: /* Products */0
                    };
          default:
            return {
                    TAG: /* Manage */7,
                    _0: /* Products */0
                  };
        }
        break;
    case "payroll" :
        const rest$9 = param.tl;
        if (!rest$9) {
          return {
                  TAG: /* Payroll */6,
                  _0: {
                    TAG: /* Employees */0,
                    _0: /* List */0
                  }
                };
        }
        switch (rest$9.hd) {
          case "employees" :
              const match$13 = rest$9.tl;
              if (!match$13) {
                return {
                        TAG: /* Payroll */6,
                        _0: {
                          TAG: /* Employees */0,
                          _0: /* List */0
                        }
                      };
              }
              const id$8 = match$13.hd;
              if (id$8 === "create" && !match$13.tl) {
                return {
                        TAG: /* Payroll */6,
                        _0: {
                          TAG: /* Employees */0,
                          _0: /* Create */1
                        }
                      };
              }
              const match$14 = match$13.tl;
              if (match$14) {
                if (match$14.hd === "edit" && !match$14.tl) {
                  return {
                          TAG: /* Payroll */6,
                          _0: {
                            TAG: /* Employees */0,
                            _0: {
                              TAG: /* Edit */1,
                              _0: id$8
                            }
                          }
                        };
                } else {
                  return {
                          TAG: /* Payroll */6,
                          _0: {
                            TAG: /* Employees */0,
                            _0: /* List */0
                          }
                        };
                }
              } else {
                return {
                        TAG: /* Payroll */6,
                        _0: {
                          TAG: /* Employees */0,
                          _0: {
                            TAG: /* View */0,
                            _0: id$8
                          }
                        }
                      };
              }
              break;
          case "payouts" :
              const match$15 = rest$9.tl;
              if (match$15) {
                if (match$15.tl) {
                  return {
                          TAG: /* Payroll */6,
                          _0: {
                            TAG: /* Employees */0,
                            _0: /* List */0
                          }
                        };
                } else {
                  return {
                          TAG: /* Payroll */6,
                          _0: {
                            TAG: /* Payouts */1,
                            _0: {
                              TAG: /* View */0,
                              _0: match$15.hd
                            }
                          }
                        };
                }
              } else {
                return {
                        TAG: /* Payroll */6,
                        _0: {
                          TAG: /* Payouts */1,
                          _0: /* List */0
                        }
                      };
              }
          default:
            return {
                    TAG: /* Payroll */6,
                    _0: {
                      TAG: /* Employees */0,
                      _0: /* List */0
                    }
                  };
        }
        break;
    case "settings" :
        const match$16 = param.tl;
        if (!match$16) {
          return {
                  TAG: /* Settings */8,
                  _0: /* General */0
                };
        }
        switch (match$16.hd) {
          case "brand" :
              if (match$16.tl) {
                return /* Dashboard */0;
              } else {
                return {
                        TAG: /* Settings */8,
                        _0: /* Brand */1
                      };
              }
          case "chief" :
              if (match$16.tl) {
                return /* Dashboard */0;
              } else {
                return {
                        TAG: /* Settings */8,
                        _0: /* Chief */2
                      };
              }
          case "tax" :
              if (match$16.tl) {
                return /* Dashboard */0;
              } else {
                return {
                        TAG: /* Settings */8,
                        _0: /* Tax */3
                      };
              }
          default:
            return /* Dashboard */0;
        }
    case "sklad" :
        const sklad = param.tl;
        if (!sklad) {
          return /* Dashboard */0;
        }
        switch (sklad.hd) {
          case "procurements" :
              const match$17 = sklad.tl;
              if (!match$17) {
                return /* Dashboard */0;
              }
              switch (match$17.hd) {
                case "orders" :
                    const rest$10 = match$17.tl;
                    if (!rest$10) {
                      return {
                              TAG: /* Sklad */3,
                              _0: {
                                TAG: /* Procurements */0,
                                _0: {
                                  TAG: /* Orders */0,
                                  _0: /* List */0
                                }
                              }
                            };
                    }
                    const id$9 = rest$10.hd;
                    if (id$9 === "create" && !rest$10.tl) {
                      return {
                              TAG: /* Sklad */3,
                              _0: {
                                TAG: /* Procurements */0,
                                _0: {
                                  TAG: /* Orders */0,
                                  _0: /* Create */1
                                }
                              }
                            };
                    }
                    const match$18 = rest$10.tl;
                    if (match$18) {
                      if (match$18.hd === "edit" && !match$18.tl) {
                        return {
                                TAG: /* Sklad */3,
                                _0: {
                                  TAG: /* Procurements */0,
                                  _0: {
                                    TAG: /* Orders */0,
                                    _0: {
                                      TAG: /* Edit */1,
                                      _0: Caml_format.caml_int_of_string(id$9)
                                    }
                                  }
                                }
                              };
                      } else {
                        return /* Dashboard */0;
                      }
                    } else {
                      return {
                              TAG: /* Sklad */3,
                              _0: {
                                TAG: /* Procurements */0,
                                _0: {
                                  TAG: /* Orders */0,
                                  _0: {
                                    TAG: /* View */0,
                                    _0: Caml_format.caml_int_of_string(id$9)
                                  }
                                }
                              }
                            };
                    }
                    break;
                case "receives" :
                    const rest$11 = match$17.tl;
                    if (!rest$11) {
                      return {
                              TAG: /* Sklad */3,
                              _0: {
                                TAG: /* Procurements */0,
                                _0: {
                                  TAG: /* Receives */1,
                                  _0: /* List */0
                                }
                              }
                            };
                    }
                    const id$10 = rest$11.hd;
                    if (id$10 === "create" && !rest$11.tl) {
                      return {
                              TAG: /* Sklad */3,
                              _0: {
                                TAG: /* Procurements */0,
                                _0: {
                                  TAG: /* Receives */1,
                                  _0: /* Create */1
                                }
                              }
                            };
                    }
                    const match$19 = rest$11.tl;
                    if (match$19) {
                      if (match$19.hd === "edit" && !match$19.tl) {
                        return {
                                TAG: /* Sklad */3,
                                _0: {
                                  TAG: /* Procurements */0,
                                  _0: {
                                    TAG: /* Receives */1,
                                    _0: {
                                      TAG: /* Edit */1,
                                      _0: Caml_format.caml_int_of_string(id$10)
                                    }
                                  }
                                }
                              };
                      } else {
                        return /* Dashboard */0;
                      }
                    } else {
                      return {
                              TAG: /* Sklad */3,
                              _0: {
                                TAG: /* Procurements */0,
                                _0: {
                                  TAG: /* Receives */1,
                                  _0: {
                                    TAG: /* View */0,
                                    _0: Caml_format.caml_int_of_string(id$10)
                                  }
                                }
                              }
                            };
                    }
                    break;
                default:
                  return /* Dashboard */0;
              }
              break;
          case "remains" :
              if (sklad.tl) {
                return /* Dashboard */0;
              } else {
                return {
                        TAG: /* Sklad */3,
                        _0: /* Remains */0
                      };
              }
          case "warehouses" :
              const rest$12 = sklad.tl;
              if (!rest$12) {
                return {
                        TAG: /* Sklad */3,
                        _0: {
                          TAG: /* Warehouses */1,
                          _0: /* List */0
                        }
                      };
              }
              const id$11 = rest$12.hd;
              if (id$11 === "create" && !rest$12.tl) {
                return {
                        TAG: /* Sklad */3,
                        _0: {
                          TAG: /* Warehouses */1,
                          _0: /* Create */1
                        }
                      };
              }
              const match$20 = rest$12.tl;
              if (match$20) {
                if (match$20.hd === "edit" && !match$20.tl) {
                  return {
                          TAG: /* Sklad */3,
                          _0: {
                            TAG: /* Warehouses */1,
                            _0: {
                              TAG: /* Edit */1,
                              _0: Caml_format.caml_int_of_string(id$11)
                            }
                          }
                        };
                } else {
                  return {
                          TAG: /* Sklad */3,
                          _0: {
                            TAG: /* Warehouses */1,
                            _0: /* List */0
                          }
                        };
                }
              } else {
                return {
                        TAG: /* Sklad */3,
                        _0: {
                          TAG: /* Warehouses */1,
                          _0: {
                            TAG: /* View */0,
                            _0: Caml_format.caml_int_of_string(id$11)
                          }
                        }
                      };
              }
              break;
          default:
            return /* Dashboard */0;
        }
        break;
    case "tax" :
        const rest$13 = param.tl;
        if (!rest$13) {
          return {
                  TAG: /* Tax */4,
                  _0: {
                    TAG: /* Payments */0,
                    _0: /* Index */0
                  }
                };
        }
        switch (rest$13.hd) {
          case "payments" :
              const match$21 = rest$13.tl;
              if (!match$21) {
                return {
                        TAG: /* Tax */4,
                        _0: {
                          TAG: /* Payments */0,
                          _0: /* Index */0
                        }
                      };
              }
              switch (match$21.hd) {
                case "employee" :
                    const match$22 = match$21.tl;
                    if (match$22 && match$22.hd === "create" && !match$22.tl) {
                      return {
                              TAG: /* Tax */4,
                              _0: {
                                TAG: /* Payments */0,
                                _0: /* Create */3
                              }
                            };
                    } else {
                      return {
                              TAG: /* Tax */4,
                              _0: {
                                TAG: /* Payments */0,
                                _0: /* Index */0
                              }
                            };
                    }
                case "orders" :
                    const match$23 = match$21.tl;
                    if (!match$23) {
                      return {
                              TAG: /* Tax */4,
                              _0: {
                                TAG: /* Payments */0,
                                _0: /* Index */0
                              }
                            };
                    }
                    switch (match$23.hd) {
                      case "checkout" :
                          if (match$23.tl) {
                            return {
                                    TAG: /* Tax */4,
                                    _0: {
                                      TAG: /* Payments */0,
                                      _0: /* Index */0
                                    }
                                  };
                          } else {
                            return {
                                    TAG: /* Tax */4,
                                    _0: {
                                      TAG: /* Payments */0,
                                      _0: /* Orders */{
                                        _0: /* Checkout */2
                                      }
                                    }
                                  };
                          }
                      case "create" :
                          if (match$23.tl) {
                            return {
                                    TAG: /* Tax */4,
                                    _0: {
                                      TAG: /* Payments */0,
                                      _0: /* Index */0
                                    }
                                  };
                          } else {
                            return {
                                    TAG: /* Tax */4,
                                    _0: {
                                      TAG: /* Payments */0,
                                      _0: /* Orders */{
                                        _0: /* Index */0
                                      }
                                    }
                                  };
                          }
                      case "employee" :
                          const match$24 = match$23.tl;
                          if (match$24 && match$24.hd === "create" && !match$24.tl) {
                            return {
                                    TAG: /* Tax */4,
                                    _0: {
                                      TAG: /* Payments */0,
                                      _0: /* Orders */{
                                        _0: /* Create */1
                                      }
                                    }
                                  };
                          } else {
                            return {
                                    TAG: /* Tax */4,
                                    _0: {
                                      TAG: /* Payments */0,
                                      _0: /* Index */0
                                    }
                                  };
                          }
                      default:
                        return {
                                TAG: /* Tax */4,
                                _0: {
                                  TAG: /* Payments */0,
                                  _0: /* Index */0
                                }
                              };
                    }
                case "settings" :
                    if (match$21.tl) {
                      return {
                              TAG: /* Tax */4,
                              _0: {
                                TAG: /* Payments */0,
                                _0: /* Index */0
                              }
                            };
                    } else {
                      return {
                              TAG: /* Tax */4,
                              _0: {
                                TAG: /* Payments */0,
                                _0: /* Settings */1
                              }
                            };
                    }
                default:
                  return {
                          TAG: /* Tax */4,
                          _0: {
                            TAG: /* Payments */0,
                            _0: /* Index */0
                          }
                        };
              }
          case "reports" :
              const match$25 = rest$13.tl;
              if (!match$25) {
                return {
                        TAG: /* Tax */4,
                        _0: {
                          TAG: /* Reports */1,
                          _0: /* List */0
                        }
                      };
              }
              const id$12 = match$25.hd;
              if (id$12 === "create" && !match$25.tl) {
                return {
                        TAG: /* Tax */4,
                        _0: {
                          TAG: /* Reports */1,
                          _0: /* Create */1
                        }
                      };
              }
              const match$26 = match$25.tl;
              if (match$26) {
                if (match$26.hd === "edit" && !match$26.tl) {
                  return {
                          TAG: /* Tax */4,
                          _0: {
                            TAG: /* Reports */1,
                            _0: {
                              TAG: /* Edit */1,
                              _0: Caml_format.caml_int_of_string(id$12)
                            }
                          }
                        };
                } else {
                  return {
                          TAG: /* Tax */4,
                          _0: {
                            TAG: /* Payments */0,
                            _0: /* Index */0
                          }
                        };
                }
              } else {
                return {
                        TAG: /* Tax */4,
                        _0: {
                          TAG: /* Reports */1,
                          _0: {
                            TAG: /* View */0,
                            _0: Caml_format.caml_int_of_string(id$12)
                          }
                        }
                      };
              }
              break;
          case "settings" :
              if (rest$13.tl) {
                return {
                        TAG: /* Tax */4,
                        _0: {
                          TAG: /* Payments */0,
                          _0: /* Index */0
                        }
                      };
              } else {
                return {
                        TAG: /* Tax */4,
                        _0: /* Settings */0
                      };
              }
          default:
            return {
                    TAG: /* Tax */4,
                    _0: {
                      TAG: /* Payments */0,
                      _0: /* Index */0
                    }
                  };
        }
        break;
    default:
      return /* Dashboard */0;
  }
}

function toString(route) {
  if (typeof route === "number") {
    switch (route) {
      case /* OrgChoose */0 :
          return "/org";
      case /* Unauthorized */1 :
          return "/unauthorized";
      case /* NotFound */2 :
          return "/error";
      
    }
  } else {
    switch (route.TAG | 0) {
      case /* Auth */0 :
          const auth = route._0;
          if (typeof auth === "number") {
            switch (auth) {
              case /* Login */0 :
                  return "/login";
              case /* Logout */1 :
                  return "/auth/logout";
              case /* Recovery */2 :
                  return "/auth/recovery";
              case /* Confirm */3 :
                  return "/auth/confirm";
              case /* ResetPassword */4 :
                  return "/auth/recovery/password";
              case /* ClientConsent */5 :
                  return "/client/consent";
              case /* ClientLogout */6 :
                  return "/client/logout";
              case /* RegisterIdentity */7 :
                  return "/auth/registration";
              case /* Error */8 :
                  return "/auth/errors";
              
            }
          } else {
            switch (auth._0) {
              case /* Credentials */0 :
                  return "/register";
              case /* PhoneActivation */1 :
                  return "/register/activate";
              case /* OrgRegistration */2 :
                  return "/register/org";
              
            }
          }
      case /* Receipt */1 :
          return "/receipt/" + (String(route._0) + ("/" + route._1));
      case /* EtpOrder */2 :
          return "/receipt/etp/" + (route._0 + ("/" + route._1));
      case /* IdentFlow */3 :
          return "/ident/" + route._0;
      case /* SignFlow */4 :
          return "/sign/" + route._0;
      case /* Profile */5 :
          switch (route._0) {
            case /* General */0 :
                return "/profile";
            case /* Security */1 :
                return "/profile/security";
            case /* API */2 :
                return "/profile/api";
            
          }
      case /* Org */6 :
          const prefix = "/org/" + String(route._0);
          const uri = orgUri(route._1);
          return prefix + uri;
      case /* Admin */7 :
          const admin = route._0;
          let uri$1;
          if (typeof admin === "number") {
            uri$1 = "";
          } else {
            switch (admin.TAG | 0) {
              case /* Keychain */0 :
                  const keychain = admin._0;
                  if (keychain.TAG === /* Keys */0) {
                    const listState = keychain._0;
                    uri$1 = typeof listState === "number" ? (
                        listState === /* List */0 ? "/keychain/keys" : "/keychain/keys/create"
                      ) : (
                        listState.TAG === /* View */0 ? "/keychain/keys/" + String(listState._0) : "/keychain/keys/" + (String(listState._0) + "/edit")
                      );
                  } else {
                    const listState$1 = keychain._0;
                    uri$1 = typeof listState$1 === "number" ? (
                        listState$1 === /* List */0 ? "/keychain/credentials" : "/keychain/credentials/create"
                      ) : (
                        listState$1.TAG === /* View */0 ? "/keychain/credentials/" + String(listState$1._0) : "/keychain/credentials/" + (String(listState$1._0) + "/edit")
                      );
                  }
                  break;
              case /* Orgs */1 :
                  const orgs = admin._0;
                  if (typeof orgs === "number") {
                    uri$1 = orgs ? "/orgs/create" : "/orgs";
                  } else {
                    const uri$2 = orgUri(orgs._1);
                    uri$1 = "/orgs/" + (String(orgs._0) + uri$2);
                  }
                  break;
              case /* Identities */2 :
                  const identityState = admin._0;
                  if (typeof identityState === "number") {
                    uri$1 = identityState ? "/identities/create" : "/identities";
                  } else {
                    const id = identityState._0;
                    switch (identityState._1) {
                      case /* General */0 :
                          uri$1 = "/identities/" + id;
                          break;
                      case /* Security */1 :
                          uri$1 = "/identities/" + (id + "/security");
                          break;
                      case /* API */2 :
                          uri$1 = "/identities/" + (id + "/api");
                          break;
                      
                    }
                  }
                  break;
              case /* Help */3 :
                  const tickets = admin._0._0;
                  uri$1 = typeof tickets === "number" ? (
                      tickets === /* List */0 ? "/help/tickets" : "/help/tickets/create"
                    ) : (
                      tickets.TAG === /* View */0 ? "/help/tickets/" + String(tickets._0) : "/help/tickets"
                    );
                  break;
              
            }
          }
          return "/admin" + uri$1;
      
    }
  }
}

function ofUrl(url) {
  const match = url.path;
  if (!match) {
    return /* NotFound */2;
  }
  switch (match.hd) {
    case "admin" :
        const rest = match.tl;
        if (!rest) {
          return {
                  TAG: /* Admin */7,
                  _0: /* Main */0
                };
        }
        switch (rest.hd) {
          case "help" :
              const rest$1 = rest.tl;
              if (!rest$1) {
                return {
                        TAG: /* Admin */7,
                        _0: {
                          TAG: /* Help */3,
                          _0: /* Tickets */{
                            _0: /* List */0
                          }
                        }
                      };
              }
              if (rest$1.hd !== "tickets") {
                return {
                        TAG: /* Admin */7,
                        _0: {
                          TAG: /* Help */3,
                          _0: /* Tickets */{
                            _0: /* List */0
                          }
                        }
                      };
              }
              const match$1 = rest$1.tl;
              if (!match$1) {
                return {
                        TAG: /* Admin */7,
                        _0: {
                          TAG: /* Help */3,
                          _0: /* Tickets */{
                            _0: /* List */0
                          }
                        }
                      };
              }
              const id = match$1.hd;
              if (id === "create") {
                if (match$1.tl) {
                  return {
                          TAG: /* Admin */7,
                          _0: {
                            TAG: /* Help */3,
                            _0: /* Tickets */{
                              _0: /* List */0
                            }
                          }
                        };
                } else {
                  return {
                          TAG: /* Admin */7,
                          _0: {
                            TAG: /* Help */3,
                            _0: /* Tickets */{
                              _0: /* Create */1
                            }
                          }
                        };
                }
              } else if (match$1.tl) {
                return {
                        TAG: /* Admin */7,
                        _0: {
                          TAG: /* Help */3,
                          _0: /* Tickets */{
                            _0: /* List */0
                          }
                        }
                      };
              } else {
                return {
                        TAG: /* Admin */7,
                        _0: {
                          TAG: /* Help */3,
                          _0: /* Tickets */{
                            _0: {
                              TAG: /* View */0,
                              _0: Caml_format.caml_int_of_string(id)
                            }
                          }
                        }
                      };
              }
          case "identities" :
              const rest$2 = rest.tl;
              if (!rest$2) {
                return {
                        TAG: /* Admin */7,
                        _0: {
                          TAG: /* Identities */2,
                          _0: /* List */0
                        }
                      };
              }
              const id$1 = rest$2.hd;
              if (id$1 === "create" && !rest$2.tl) {
                return {
                        TAG: /* Admin */7,
                        _0: {
                          TAG: /* Identities */2,
                          _0: /* Create */1
                        }
                      };
              }
              const match$2 = rest$2.tl;
              if (!match$2) {
                return {
                        TAG: /* Admin */7,
                        _0: {
                          TAG: /* Identities */2,
                          _0: /* Item */{
                            _0: id$1,
                            _1: /* General */0
                          }
                        }
                      };
              }
              switch (match$2.hd) {
                case "api" :
                    if (match$2.tl) {
                      return {
                              TAG: /* Admin */7,
                              _0: {
                                TAG: /* Identities */2,
                                _0: /* List */0
                              }
                            };
                    } else {
                      return {
                              TAG: /* Admin */7,
                              _0: {
                                TAG: /* Identities */2,
                                _0: /* Item */{
                                  _0: id$1,
                                  _1: /* API */2
                                }
                              }
                            };
                    }
                case "security" :
                    if (match$2.tl) {
                      return {
                              TAG: /* Admin */7,
                              _0: {
                                TAG: /* Identities */2,
                                _0: /* List */0
                              }
                            };
                    } else {
                      return {
                              TAG: /* Admin */7,
                              _0: {
                                TAG: /* Identities */2,
                                _0: /* Item */{
                                  _0: id$1,
                                  _1: /* Security */1
                                }
                              }
                            };
                    }
                default:
                  return {
                          TAG: /* Admin */7,
                          _0: {
                            TAG: /* Identities */2,
                            _0: /* List */0
                          }
                        };
              }
              break;
          case "keychain" :
              const match$3 = rest.tl;
              if (!match$3) {
                return /* NotFound */2;
              }
              switch (match$3.hd) {
                case "credentials" :
                    const rest$3 = match$3.tl;
                    if (!rest$3) {
                      return {
                              TAG: /* Admin */7,
                              _0: {
                                TAG: /* Keychain */0,
                                _0: {
                                  TAG: /* Credentials */1,
                                  _0: /* List */0
                                }
                              }
                            };
                    }
                    const id$2 = rest$3.hd;
                    if (id$2 === "create" && !rest$3.tl) {
                      return {
                              TAG: /* Admin */7,
                              _0: {
                                TAG: /* Keychain */0,
                                _0: {
                                  TAG: /* Credentials */1,
                                  _0: /* Create */1
                                }
                              }
                            };
                    }
                    const match$4 = rest$3.tl;
                    if (match$4) {
                      if (match$4.hd === "edit" && !match$4.tl) {
                        return {
                                TAG: /* Admin */7,
                                _0: {
                                  TAG: /* Keychain */0,
                                  _0: {
                                    TAG: /* Credentials */1,
                                    _0: {
                                      TAG: /* Edit */1,
                                      _0: Caml_format.caml_int_of_string(id$2)
                                    }
                                  }
                                }
                              };
                      } else {
                        return {
                                TAG: /* Admin */7,
                                _0: {
                                  TAG: /* Keychain */0,
                                  _0: {
                                    TAG: /* Credentials */1,
                                    _0: /* List */0
                                  }
                                }
                              };
                      }
                    } else {
                      return {
                              TAG: /* Admin */7,
                              _0: {
                                TAG: /* Keychain */0,
                                _0: {
                                  TAG: /* Credentials */1,
                                  _0: {
                                    TAG: /* View */0,
                                    _0: Caml_format.caml_int_of_string(id$2)
                                  }
                                }
                              }
                            };
                    }
                    break;
                case "keys" :
                    const rest$4 = match$3.tl;
                    if (!rest$4) {
                      return {
                              TAG: /* Admin */7,
                              _0: {
                                TAG: /* Keychain */0,
                                _0: {
                                  TAG: /* Keys */0,
                                  _0: /* List */0
                                }
                              }
                            };
                    }
                    const id$3 = rest$4.hd;
                    if (id$3 === "create" && !rest$4.tl) {
                      return {
                              TAG: /* Admin */7,
                              _0: {
                                TAG: /* Keychain */0,
                                _0: {
                                  TAG: /* Keys */0,
                                  _0: /* Create */1
                                }
                              }
                            };
                    }
                    const match$5 = rest$4.tl;
                    if (match$5) {
                      if (match$5.hd === "edit" && !match$5.tl) {
                        return {
                                TAG: /* Admin */7,
                                _0: {
                                  TAG: /* Keychain */0,
                                  _0: {
                                    TAG: /* Keys */0,
                                    _0: {
                                      TAG: /* Edit */1,
                                      _0: Caml_format.caml_int_of_string(id$3)
                                    }
                                  }
                                }
                              };
                      } else {
                        return {
                                TAG: /* Admin */7,
                                _0: {
                                  TAG: /* Keychain */0,
                                  _0: {
                                    TAG: /* Keys */0,
                                    _0: /* List */0
                                  }
                                }
                              };
                      }
                    } else {
                      return {
                              TAG: /* Admin */7,
                              _0: {
                                TAG: /* Keychain */0,
                                _0: {
                                  TAG: /* Keys */0,
                                  _0: {
                                    TAG: /* View */0,
                                    _0: Caml_format.caml_int_of_string(id$3)
                                  }
                                }
                              }
                            };
                    }
                    break;
                default:
                  return /* NotFound */2;
              }
              break;
          case "orgs" :
              const rest$5 = rest.tl;
              if (!rest$5) {
                return {
                        TAG: /* Admin */7,
                        _0: {
                          TAG: /* Orgs */1,
                          _0: /* List */0
                        }
                      };
              }
              const id$4 = rest$5.hd;
              switch (id$4) {
                case "" :
                    if (!rest$5.tl) {
                      return {
                              TAG: /* Admin */7,
                              _0: {
                                TAG: /* Orgs */1,
                                _0: /* List */0
                              }
                            };
                    }
                    break;
                case "create" :
                    if (!rest$5.tl) {
                      return {
                              TAG: /* Admin */7,
                              _0: {
                                TAG: /* Orgs */1,
                                _0: /* Create */1
                              }
                            };
                    }
                    break;
                default:
                  
              }
              return {
                      TAG: /* Admin */7,
                      _0: {
                        TAG: /* Orgs */1,
                        _0: /* Org */{
                          _0: Caml_format.caml_int_of_string(id$4),
                          _1: orgRoute(rest$5.tl)
                        }
                      }
                    };
              break;
          case "unauthorized" :
              if (rest.tl) {
                return /* NotFound */2;
              } else {
                return /* Unauthorized */1;
              }
          default:
            return /* NotFound */2;
        }
        break;
    case "auth" :
        const match$6 = match.tl;
        if (!match$6) {
          return /* NotFound */2;
        }
        switch (match$6.hd) {
          case "confirm" :
              if (match$6.tl) {
                return /* NotFound */2;
              } else {
                return {
                        TAG: /* Auth */0,
                        _0: /* Confirm */3
                      };
              }
          case "errors" :
              if (match$6.tl) {
                return /* NotFound */2;
              } else {
                return {
                        TAG: /* Auth */0,
                        _0: /* Error */8
                      };
              }
          case "logout" :
              if (match$6.tl) {
                return /* NotFound */2;
              } else {
                return {
                        TAG: /* Auth */0,
                        _0: /* Logout */1
                      };
              }
          case "recovery" :
              const match$7 = match$6.tl;
              if (match$7) {
                if (match$7.hd === "password" && !match$7.tl) {
                  return {
                          TAG: /* Auth */0,
                          _0: /* ResetPassword */4
                        };
                } else {
                  return /* NotFound */2;
                }
              } else {
                return {
                        TAG: /* Auth */0,
                        _0: /* Recovery */2
                      };
              }
          case "registration" :
              if (match$6.tl) {
                return /* NotFound */2;
              } else {
                return {
                        TAG: /* Auth */0,
                        _0: /* RegisterIdentity */7
                      };
              }
          default:
            return /* NotFound */2;
        }
    case "client" :
        const match$8 = match.tl;
        if (!match$8) {
          return /* NotFound */2;
        }
        switch (match$8.hd) {
          case "consent" :
              if (match$8.tl) {
                return /* NotFound */2;
              } else {
                return {
                        TAG: /* Auth */0,
                        _0: /* ClientConsent */5
                      };
              }
          case "logout" :
              if (match$8.tl) {
                return /* NotFound */2;
              } else {
                return {
                        TAG: /* Auth */0,
                        _0: /* ClientLogout */6
                      };
              }
          default:
            return /* NotFound */2;
        }
    case "ident" :
        const match$9 = match.tl;
        if (match$9 && !match$9.tl) {
          return {
                  TAG: /* IdentFlow */3,
                  _0: match$9.hd
                };
        } else {
          return /* NotFound */2;
        }
    case "login" :
        if (match.tl) {
          return /* NotFound */2;
        } else {
          return {
                  TAG: /* Auth */0,
                  _0: /* Login */0
                };
        }
    case "org" :
        const match$10 = match.tl;
        if (!match$10) {
          return /* OrgChoose */0;
        }
        const org = Caml_format.caml_int_of_string(match$10.hd);
        return {
                TAG: /* Org */6,
                _0: org,
                _1: orgRoute(match$10.tl)
              };
    case "profile" :
        const match$11 = match.tl;
        if (!match$11) {
          return {
                  TAG: /* Profile */5,
                  _0: /* General */0
                };
        }
        switch (match$11.hd) {
          case "api" :
              if (match$11.tl) {
                return /* NotFound */2;
              } else {
                return {
                        TAG: /* Profile */5,
                        _0: /* API */2
                      };
              }
          case "security" :
              if (match$11.tl) {
                return /* NotFound */2;
              } else {
                return {
                        TAG: /* Profile */5,
                        _0: /* Security */1
                      };
              }
          default:
            return /* NotFound */2;
        }
    case "receipt" :
        const match$12 = match.tl;
        if (!match$12) {
          return /* NotFound */2;
        }
        const kkm = match$12.hd;
        const match$13 = match$12.tl;
        if (!match$13) {
          return /* NotFound */2;
        }
        if (!match$13.tl) {
          return {
                  TAG: /* Receipt */1,
                  _0: Caml_format.caml_int_of_string(kkm),
                  _1: match$13.hd
                };
        }
        if (kkm !== "etp") {
          return /* NotFound */2;
        }
        const match$14 = match$12.tl;
        const match$15 = match$14.tl;
        if (match$15.tl) {
          return /* NotFound */2;
        } else {
          return {
                  TAG: /* EtpOrder */2,
                  _0: match$14.hd,
                  _1: match$15.hd
                };
        }
    case "register" :
        const rest$6 = match.tl;
        if (!rest$6) {
          return {
                  TAG: /* Auth */0,
                  _0: /* Register */{
                    _0: /* Credentials */0
                  }
                };
        }
        switch (rest$6.hd) {
          case "activate" :
              if (rest$6.tl) {
                return {
                        TAG: /* Auth */0,
                        _0: /* Register */{
                          _0: /* Credentials */0
                        }
                      };
              } else {
                return {
                        TAG: /* Auth */0,
                        _0: /* Register */{
                          _0: /* PhoneActivation */1
                        }
                      };
              }
          case "org" :
              if (rest$6.tl) {
                return {
                        TAG: /* Auth */0,
                        _0: /* Register */{
                          _0: /* Credentials */0
                        }
                      };
              } else {
                return {
                        TAG: /* Auth */0,
                        _0: /* Register */{
                          _0: /* OrgRegistration */2
                        }
                      };
              }
          default:
            return {
                    TAG: /* Auth */0,
                    _0: /* Register */{
                      _0: /* Credentials */0
                    }
                  };
        }
    case "sign" :
        const match$16 = match.tl;
        if (match$16 && !match$16.tl) {
          return {
                  TAG: /* SignFlow */4,
                  _0: match$16.hd
                };
        } else {
          return /* NotFound */2;
        }
    default:
      return /* NotFound */2;
  }
}

function contextRoute(ctx, org, route) {
  if (ctx) {
    return {
            TAG: /* Admin */7,
            _0: {
              TAG: /* Orgs */1,
              _0: /* Org */{
                _0: org,
                _1: route
              }
            }
          };
  } else {
    return {
            TAG: /* Org */6,
            _0: org,
            _1: route
          };
  }
}

function navigateTo(page) {
  ReasonReactRouter.push(toString(page));
}

function navigateWithContextTo(ctx, org, route) {
  const page = contextRoute(ctx, org, route);
  ReasonReactRouter.push(toString(page));
}

function updateBrowserLocation(url) {
  const title = document.title;
  window.history.pushState(window.history.state, title, url);
}

function urlWithParams(url, params) {
  const url$1 = toString(url);
  const params$1 = Belt__Belt_List.toArray(Belt__Belt_List.map(params, (function (param) {
                return param[0] + ("=" + param[1]);
              }))).join("&");
  return url$1 + ("?" + params$1);
}

function setUrlParams(params) {
  const url = window.location.href.replace(window.location.search, "");
  const params$1 = Belt__Belt_List.toArray(Belt__Belt_List.map(params, (function (param) {
                return param[0] + ("=" + param[1]);
              }))).join("&");
  ReasonReactRouter.push(url + ("?" + params$1));
}

function getParamValue(url, param, param$1) {
  const searchParams = new URLSearchParams(url.search);
  return Caml_option.nullable_to_opt(searchParams.get(param));
}

function useParamValue(url, paramName) {
  const match = React.useState(function () {
        return getParamValue(url, paramName, undefined);
      });
  const setValue = match[1];
  const handleValueChange = function (value) {
    const searchParams = new URLSearchParams(window.location.search);
    const keys = Belt__Belt_List.fromArray(Array.from(searchParams.keys()));
    const params = Belt__Belt_List.keepMap(keys, (function (key) {
            if (key === paramName) {
              return ;
            }
            const value = getParamValue(url, key, undefined);
            if (value !== undefined) {
              return [
                      key,
                      value
                    ];
            }
            
          }));
    const params$1 = value !== undefined ? Stdlib.$at(params, {
            hd: [
              paramName,
              value
            ],
            tl: /* [] */0
          }) : params;
    setUrlParams(params$1);
    Curry._1(setValue, (function (param) {
            return value;
          }));
  };
  return [
          match[0],
          handleValueChange
        ];
}

function dispatchPopStateEvent(param) {
  window.dispatchEvent(new Event("popState"));
}

export {
  isProtected ,
  getListStateUrl ,
  getListStateStrUrl ,
  orgUri ,
  orgRoute ,
  toString ,
  ofUrl ,
  contextRoute ,
  navigateTo ,
  navigateWithContextTo ,
  updateBrowserLocation ,
  urlWithParams ,
  setUrlParams ,
  getParamValue ,
  useParamValue ,
  dispatchPopStateEvent ,
}
/* ReasonReactRouter Not a pure module */
